<template>
    <div class="ui-block-loader">
        <div
            class="ui-block-loader-spinner"
            v-bind:class="{
                _dark: dark,
                _light: light,
                _centered: centered,
                _mini: isMini,
                _sm: size === 'sm',
                _md: size === 'md',
                _lg: size === 'lg',
            }"
            v-bind:style="{
                width: fixed ? fixed + 'px' : null,
                paddingTop: fixed ? fixed + 'px' : null,
            }"
        />
    </div>
</template>

<script>
export default {
    name: 'ui-block-loader',
    props: {
        dark: {
            type: Boolean,
            default: false,
        },
        light: {
            type: Boolean,
            default: false,
        },
        centered: {
            type: Boolean,
            default: false,
        },
        isMini: {
            type: Boolean,
            default: false,
        },
        fixed: {
            type: Number,
            default: null,
        },
        size: {
            type: String,
            default: 'md', // sm, md, lg
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.ui-block-loader {
    .transition-fade();

    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;

    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    &-spinner {
        .transition-fade();

        position: relative;

        display: inline-block;
        width: 100px;
        height: 100px;

        color: @color-primary-2;
        &:after {
            content: '';

            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;

            display: block;
            width: 100%;
            height: 100%;
            border: 4px solid currentColor;
            // border-color: currentColor currentColor @color-gray-main @color-gray-main;
            border-color: currentColor currentColor @color-gray-light-secondary @color-gray-light-secondary;
            border-radius: 50%;

            animation: loader 1s linear infinite;
        }
        &._sm {
            width: 50px;
            height: 50px;
        }
        &._md {
            width: 100px;
            height: 100px;
        }
        &._lg {
            width: 150px;
            height: 150px;
        }
        &._dark {
            color: @color-gray-dark;
        }
        &._light {
            &:after {
                border-color: @color-gray-light @color-gray-light @color-primary @color-primary;
            }
        }
        &._centered {
            display: block;
            margin: auto;
        }
        &._mini {
            &:after {
                border: 2px solid currentColor;
                border-color: currentColor currentColor transparent;
            }
        }
    }
}
@keyframes loader {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
